import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { BoxForm, FormControlDefault, MenuItemStyled, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { toast } from 'react-toastify';
import { createEntity, getEntity, reset, updateEntity } from './tire-tread-model.reducer';

export const TireTreadModelUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const hasSaved = useRef(false);

  const tireTreadModelEntity = useAppSelector(state => state.tireTreadModel.entity);
  const loading = useAppSelector(state => state.tireTreadModel.loading);
  const updating = useAppSelector(state => state.tireTreadModel.updating);
  const updateSuccess = useAppSelector(state => state.tireTreadModel.updateSuccess);

  const [formData, setFormData] = useState({
    name: null,
    specification: null,
    groove: null,
    tireTreadManufacturer: null,
  });

  useEffect(() => {
    if (!isNew && tireTreadModelEntity) {
      setFormData({
        name: tireTreadModelEntity.name,
        specification: tireTreadModelEntity.specification,
        groove: tireTreadModelEntity.groove,
        tireTreadManufacturer: tireTreadModelEntity.tireTreadManufacturer,
      });
    }
  }, [tireTreadModelEntity]);

  const handleClose = () => {
    props.history.push('/tire-tread-model' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess && hasSaved.current) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...tireTreadModelEntity,
      ...values,
    };

    hasSaved.current = true;

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!formData?.name) {
      return toast.error('Insira um nome (exemplo: M792 ECO)');
    }

    if (!formData?.specification) {
      return toast.error('Insira uma medida (exemplo: 295/80R22.5)');
    }

    if (!formData?.groove) {
      return toast.error('Insira um sulco (exemplo: 23.5)');
    }
    
    if (!formData?.tireTreadManufacturer) {
      return toast.error('Selecione uma marca (exemplo: Bridgestone)');
    }

    saveEntity(formData);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <RegisterLayout>
          <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
            <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.tireTreadModel'} />
            <Box>
              {loading ? (
                <Box>
                  <Typography>Loading...</Typography>
                </Box>
              ) : (
                <Box margin={'0 auto'} width={'100%'}>
                  <BoxForm onSubmit={handleSubmit}>
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.tireTreadModel.name')}</TypographyForms>
                      <TextFieldForms
                        value={formData['name']}
                        id={'tire-tread-model-name'}
                        data-cy={'name'}
                        name={'name'}
                        onChange={e => handleInputChange('name', e.target.value)}
                      />
                    </FormControlDefault>

                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.tireTreadModel.specification')}</TypographyForms>
                      <TextFieldForms
                        value={formData['specification']}
                        id={'tire-tread-model-specification'}
                        data-cy={'specification'}
                        name={'specification'}
                        onChange={e => handleInputChange('specification', e.target.value)}
                      />
                    </FormControlDefault>

                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.tireTreadModel.groove')}</TypographyForms>
                      <TextFieldForms
                        value={formData['groove']}
                        id={'tire-tread-model-groove'}
                        data-cy={'groove'}
                        name={'groove'}
                        onChange={e => {
                          const value = e.target.value;
                          if (/^\d*([,.]\d*)?$/.test(value)) {
                            const normalizedValue = value?.replace(',', '.');
                            handleInputChange('groove', normalizedValue);
                          }
                        }}
                        inputProps={{
                          inputMode: 'decimal',
                          pattern: '\\d*([,.]\\d*)?',
                        }}
                      />
                    </FormControlDefault>

                    <FormControlDefault>
                      <SelectPaginate
                        label={translate('fleetSenseApp.tireTreadModel.tireTreadManufacturer')}
                        apiUrl={'api/tire-tread-manufacturers'}
                        onChange={value => handleInputChange('tireTreadManufacturer', value)}
                        value={formData['tireTreadManufacturer']}
                        valueName="name"
                        icon="sort-down"
                        statusFilter
                        filterStyle={true}
                        searchName="brandSearch"
                        displayFormat={option => `${option.name ?? ''} ${option.type ? `(${option.type})` : ''}`}
                      />
                    </FormControlDefault>

                    <RegisterButton />
                  </BoxForm>
                </Box>
              )}
            </Box>
          </Box>
        </RegisterLayout>
      </ThemeProvider>
    </>
  );
};

export default TireTreadModelUpdate;